import { Injectable } from '@angular/core';
import { ZoneId } from '@js-joda/core';
import '@js-joda/timezone';

import { TimezoneService } from '../../../core/utils/timezone.service';

export type PickerInputValue = string | Date | (Date | null)[] | null | undefined;

type InputDate = string | Date | number;

@Injectable({ providedIn: 'root' })
export class DateTimePickerService {
  constructor(private timezoneService: TimezoneService) { }

  normalizeRange(values: PickerInputValue): [any, any] {
    if (typeof values === 'string') {
      const d = new Date(values);
      return [d, d];
    }
    if (Array.isArray(values)) {
      const from = values[0];
      const to = values.length >= 2 ? values[1] : values[0];
      return [from, to];
    }
    return [values, values];
  }

  toUtcStart(
    date: InputDate,
    tz: string = this.timezoneService.getUserTimeZone()
  ): string {
    const localDate = this.timezoneService.toLocalDateInZone(date, tz);
    return localDate.atStartOfDay().atZone(ZoneId.of(tz)).toInstant().toString();
  }

  toUtcEnd(
    date: InputDate,
    tz: string = this.timezoneService.getUserTimeZone()
  ): string {
    const localDate = this.timezoneService.toLocalDateInZone(date, tz);
    return localDate
      .atTime(23, 59, 59, 999_000_000)
      .atZone(ZoneId.of(tz))
      .toInstant()
      .toString();
  }

  rangeToUtc(
    fromDate: InputDate,
    toDate: InputDate,
    tz: string = this.timezoneService.getUserTimeZone()
  ): { start: string; end: string } {
    return {
      start: this.toUtcStart(fromDate, tz),
      end: this.toUtcEnd(toDate, tz),
    };
  }

  toUtcRange(
    raw: PickerInputValue,
    tz: string = this.timezoneService.getUserTimeZone()
  ): { start: string; end: string } {
    const [from, to] = this.normalizeRange(raw);
    return this.rangeToUtc(from, to, tz);
  }

}
